import { BaseEntity } from "../base/base-entity";
import {
  ProcedureAssignmentSettingRuleSet,
  TargetField,
  AssignmentRule,
} from "./procedure-assignment-setting-ruleset";

export class ProcedureAssignmentSettingRuleSetEntity
  extends BaseEntity
  implements ProcedureAssignmentSettingRuleSet
{
  readonly id: string;
  readonly tenantId: string;
  readonly name: string;
  readonly description: string;
  readonly version: number;
  readonly targetFields: TargetField[];
  readonly rules: AssignmentRule[];
  readonly archivedAtUnixTime: number;
  readonly archivedBy: string;
  readonly createdAt: string;
  readonly updatedAt: string;

  constructor(data: ProcedureAssignmentSettingRuleSet) {
    super();
    this.id = data.id;
    this.tenantId = data.tenantId;
    this.name = data.name;
    this.description = data.description;
    this.version = data.version;
    this.targetFields = data.targetFields;
    this.rules = data.rules;
    this.archivedAtUnixTime = data.archivedAtUnixTime;
    this.archivedBy = data.archivedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  static fromJSON(
    json: ProcedureAssignmentSettingRuleSet,
  ): ProcedureAssignmentSettingRuleSetEntity {
    return new ProcedureAssignmentSettingRuleSetEntity(json);
  }

  static fromJSONArray(
    jsonArray?: ProcedureAssignmentSettingRuleSet[],
  ): ProcedureAssignmentSettingRuleSetEntity[] {
    if (!jsonArray) {
      return [];
    }
    return jsonArray.map(ProcedureAssignmentSettingRuleSetEntity.fromJSON);
  }

  // 必要に応じてゲッターやドメインロジックメソッドを追加
  // 例:
  // get isActive(): boolean {
  //   return this.archivedAtUnixTime === 0; // バックエンドの UnArchivedUnixTime = 0 に合わせる
  // }
}
